/* BushLine size guide - 14 Oct 2026 (thread AF, the owner's "4 Tape Measure" pick and the locked Size Guide tab).
   1. The product's own guide: the "Size Guide: Find your Fit" button under the size buttons (snippets/bushline-size-guide.liquid)
      opens a tape over the page. The customer types or slides one measurement (mm by default, cm on the switch); the tape has
      one zone per size button; the answer ticks that size button for them. Data = product metafield bushline.size_guide (JSON).
   2. The Size Guide tab (Tabs Studio): its old content is swapped for the measure-once guide (chest, waist, foot).
   3. Sizes saved on this device (localStorage "blMySizes"): the page ticks the saved person's size by itself, and
      "Shopping for" appears above the sizes once someone other than "Me" is saved.
   Every number on the tape comes from the product's own data; nothing here invents a size. */
(function () {
  if (window.blSG && window.blSG.ready) return;
  var SG = window.blSG = window.blSG || {};
  SG.ready = true;
  // The owner's picks, 14 Oct 2026: the button opens this product's tape over the page ('tab' = jump to the Size Guide tab
  // instead), and one extra line shows in the top third of a size, never more than 2 cm (false = one size, no line).
  SG.mode = SG.mode || 'overlay';
  SG.edge = SG.edge === undefined ? true : SG.edge;

  var LS = 'blMySizes';
  var LABEL = { chest: 'Chest', waist: 'Waist', foot: 'Foot Length', hand: 'Hand', hand_length: 'Hand Length', head: 'Head',
    dog_chest: 'Your Dog’s Chest', dog_neck: 'Your Dog’s Neck', knee: 'Knee', ankle: 'Ankle', finger: 'Finger' };
  var HOW = {
    chest: 'Run the tape round the fullest part of your chest, under the arms. Keep it level and snug, not tight.',
    waist: 'Run the tape round your natural waist, about 1 cm below your navel.',
    foot: 'Stand on a sheet of paper against a wall and measure from your heel to your longest toe.',
    hand: 'Wrap the tape round your hand across the knuckles, leaving the thumb out.',
    hand_length: 'Measure from the crease of your wrist to the tip of your middle finger.',
    head: 'Run the tape round your head, about 1 cm above your eyebrows and ears.',
    dog_chest: 'Run the tape round the widest part of your dog’s chest, just behind the front legs.',
    dog_neck: 'Run the tape round your dog’s neck where the collar sits.',
    knee: 'Measure round your leg where the maker’s chart says (see the measurements below).',
    ankle: 'Measure round your ankle where the maker’s chart says (see the measurements below).',
    finger: 'Measure round the finger the ring is for (see the measurements below).'
  };
  // The store-wide Size Guide tab charts (body sizes; the owner's locked model, 14 Oct 2026).
  var CH = {
    jk: [['XS', 87], ['S', 92], ['M', 97], ['L', 102], ['XL', 107], ['2XL', 112], ['3XL', 117], ['4XL', 122], ['5XL', 127], ['6XL', 132]],
    pa: [['XS', 77], ['S', 82], ['M', 87], ['L', 92], ['XL', 97], ['2XL', 102], ['3XL', 107], ['4XL', 112], ['5XL', 117], ['6XL', 122]],
    wb: [['6', 80], ['8', 85], ['10', 90], ['12', 95], ['14', 100], ['16', 105], ['18', 110], ['20', 115], ['22', 120], ['24', 125]],
    ww: [['6', 60], ['8', 65], ['10', 70], ['12', 75], ['14', 80], ['16', 85], ['18', 90], ['20', 95], ['22', 100], ['24', 105]],
    ft: [['AU 6', 24.5], ['AU 7', 25], ['AU 7.5', 25.5], ['AU 8', 26], ['AU 8.5', 26.5], ['AU 9', 27], ['AU 9.5', 27.5], ['AU 10.5', 28], ['AU 11', 28.5], ['AU 11.5', 29]]
  };

  // ---------- saved sizes (this device) ----------
  function load() {
    var d = null;
    try { d = JSON.parse(localStorage.getItem(LS) || 'null'); } catch (e) {}
    if (!d || !d.people || !d.people.length) d = { unit: 'mm', people: [{ name: 'Me', kind: 'men' }], shopFor: 0, saved: false };
    if (d.unit !== 'cm') d.unit = 'mm';
    if (!(d.shopFor >= 0 && d.shopFor < d.people.length)) d.shopFor = 0;
    return d;
  }
  var S = load();
  var cur = S.shopFor;           // whose sizes the guide is showing
  function store() { try { localStorage.setItem(LS, JSON.stringify(S)); return localStorage.getItem(LS) !== null; } catch (e) { return false; } }

  // ---------- helpers ----------
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function k() { return S.unit === 'mm' ? 10 : 1; }
  function fmt(cm) { return S.unit === 'mm' ? Math.round(cm * 10) + ' mm' : (Math.round(cm * 10) / 10) + ' cm'; }
  function num(cm) { return S.unit === 'mm' ? Math.round(cm * 10) : Math.round(cm * 10) / 10; }
  function short(v) { var s = String(v).replace(/^AU\s+/i, '').replace(/\s*\(.*$/, '').replace(/-(\(|chest).*$/i, '').trim(); return s || String(v); }
  function zoneOf(sizes, v) { for (var i = 0; i < sizes.length; i++) { if (v <= sizes[i].max + 1e-9) return i; } return -1; }
  // The page's own "between sizes, go up" advice (data: measure.between = {mode:'overlap'|'top', margin}, sizes[].min):
  // 'overlap' - inside (or on the line of) the next size's range too -> the next size up;
  // 'top'     - inside the next size's range AND within `margin` cm of the top of this one -> the next size up.
  function pickZone(m, v) {
    var s = m.sizes, zi = zoneOf(s, v), b = m.between;
    if (!b || zi < 0 || zi >= s.length - 1 || !(s[zi + 1].min >= 0) || v < s[zi + 1].min - 1e-9) return { zi: zi, up: false };
    if (b.mode === 'top' && s[zi].max - v > (b.margin || 2) + 1e-9) return { zi: zi, up: false };
    return { zi: zi + 1, up: true, from: zi };
  }
  function lowEnd(sizes) {
    // the first size gets a zone as wide as the next one (anything smaller still lands on the first size)
    var a = sizes[0].max, step = sizes.length > 1 ? sizes[1].max - sizes[0].max : 5;
    return Math.max(0, a - (step > 0 ? step : 5));
  }
  function rangeText(sizes, i) {
    if (i === 0) return 'up to ' + fmt(sizes[0].max);
    var lo = sizes[i - 1].max + (S.unit === 'mm' ? 0.1 : 0.5);
    return num(lo) + '–' + fmt(sizes[i].max);
  }
  function person() { return S.people[cur] || S.people[0]; }
  function nameOf(p) { return p.name === 'Me' ? 'your' : p.name + '’s'; }

  // ---------- the product's data ----------
  function dataFor(el) {
    var wrap = el.closest ? el.closest('.bl-sg-wrap') : null;
    var tag = (wrap && wrap.querySelector('script.bl-sg-data')) || document.querySelector('script.bl-sg-data');
    if (!tag) return null;
    try { var d = JSON.parse(tag.textContent); return d && d.measures && d.measures.length ? d : null; } catch (e) { return null; }
  }
  function pickerFor(el) { var p = el.closest && el.closest('variant-picker'); return p || document.querySelector('.product-info variant-picker, variant-picker'); }
  function sizeFieldset(picker, d) {
    if (!picker) return null;
    var fs = picker.querySelectorAll('fieldset.option-selector, .option-selector');
    for (var i = 0; i < fs.length; i++) { if (fs[i].getAttribute('data-option') === d.option) return fs[i]; }
    return null;
  }
  // The answer for a person across every measure of this product: the biggest size any measure needs.
  function answer(d, p) {
    var idxs = [], any = false;
    d.measures.forEach(function (m) {
      var v = p[m.key]; if (!(v > 0)) { idxs.push(null); return; }
      any = true; var z = pickZone(m, v).zi; idxs.push(z < 0 ? 'over' : z);
    });
    if (!any) return null;
    if (idxs.indexOf(null) >= 0) return { partial: true, idxs: idxs };
    if (idxs.indexOf('over') >= 0) return { over: true, idxs: idxs };
    // every measure lists the same option values in the same order (the variant list), so take the larger position
    var best = -1, val = null;
    idxs.forEach(function (z, j) { var v = d.measures[j].sizes[z].value; var pos = d.measures[0].sizes.map(function (s) { return s.value; }).indexOf(v); if (pos > best) { best = pos; val = v; } });
    return { value: val, idxs: idxs };
  }
  function tick(d, value, scope) {
    var fs = sizeFieldset(pickerFor(scope), d); if (!fs) return false;
    var inputs = fs.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].value === value) {
        if (inputs[i].checked) return true;
        var lab = fs.querySelector('label[for="' + inputs[i].id + '"]');
        (lab || inputs[i]).click();
        // phones show the sizes as a drop-down (snippets/variant-picker.liquid, 12 Oct): show the same size there straight away
        var sel = fs.querySelector('select.bl-phone-select');
        if (sel) { for (var j = 0; j < sel.options.length; j++) { if (sel.options[j].value === value) { sel.selectedIndex = j; break; } } }
        return true;
      }
    }
    return false;
  }

  // ---------- one tape block ----------
  function tapeBlock(m, n, p, opt) {
    var sizes = m.sizes, min = lowEnd(sizes), max = sizes[sizes.length - 1].max, span = max - min;
    var v = p[m.key] > 0 ? p[m.key] : null, pk = v == null ? { zi: -2 } : pickZone(m, v), zi = pk.zi;
    var pos = v == null ? -10 : Math.max(0, Math.min(100, (v - min) / span * 100));
    var zones = sizes.map(function (s, i) {
      var lo = i ? sizes[i - 1].max : min;
      return '<div class="bl-sg-zone' + (i === zi ? ' is-hit' : '') + '" style="width:' + ((s.max - lo) / span * 100) + '%"><span>' + esc(opt && opt.labels ? s.label || s.value : short(s.value)) + '</span></div>';
    }).join('');
    var ticks = [0, 0.25, 0.5, 0.75, 1].map(function (t, j) { return '<span>' + num(min + span * t) + (j === 4 ? ' ' + S.unit : '') + '</span>'; }).join('');
    var title = (opt && opt.title) || m.title || LABEL[m.key] || m.key;
    var how = (opt && opt.how) || m.how || HOW[m.key] || '';
    var ans;
    // the measurement in a sentence: "Your chest", "Your dog’s neck" (titles that already start with "Your" keep it once)
    var noun = title.toLowerCase().replace(/^your\s+/, ''), yours = 'Your ' + esc(noun), aNoun = 'a ' + esc(noun);
    if (v == null) ans = '<span class="bl-sg-wait">Type your ' + esc(noun) + ' or slide the tape.</span>';
    else if (zi < 0) ans = yours + ' ' + fmt(v) + ' is bigger than ' + esc((opt && opt.over) || 'this one’s chart goes') + '<span>The largest, ' + esc(sizes[sizes.length - 1].value) + ', fits up to ' + fmt(max) + '</span>';
    else {
      // where the maker gives a range (dog gear, supports, caps, gloves) show the maker's own range for the size
      var rt = sizes[zi].min >= 0 ? num(sizes[zi].min) + '–' + fmt(sizes[zi].max) : rangeText(sizes, zi);
      ans = yours + ' ' + fmt(v) + ' → ' + esc((opt && opt.pickWord) || 'pick') + '<b>' + esc(sizes[zi].value) + '</b><span>Fits ' + ((opt && opt.fitsWord) ? esc(opt.fitsWord) : aNoun) + ' of ' + rt + ((opt && opt.extra) ? ' · ' + opt.extra : '') + '</span>';
      if (pk.up) ans += '<span class="bl-sg-edge">' + esc(m.between.say || 'Also inside the {a} range. Between two sizes, go up, so we’ve ticked {b}.').split('{a}').join(esc(sizes[pk.from].value)).split('{b}').join(esc(sizes[zi].value)) + '</span>';
      // "right at the top": the top third of this size's zone, never more than 2 cm (boot sizes are only 5 mm wide)
      var zw = sizes[zi].max - (zi ? sizes[zi - 1].max : min);
      var why = { chest: 'if you like room or wear it over layers', waist: 'if you like it looser', foot: 'with thick socks or a wide foot' }[m.key] || 'if you’re unsure';
      if (SG.edge && !pk.up && !(opt && opt.noEdge) && zi < sizes.length - 1 && sizes[zi].max - v <= Math.min(2, zw / 3)) ans += '<span class="bl-sg-edge">Right at the top of ' + esc(sizes[zi].value) + ': ' + why + ', ' + esc(sizes[zi + 1].value) + '.</span>';
    }
    return '<div class="bl-sg-block" data-key="' + m.key + '">'
      + '<div class="bl-sg-bh"><span class="bl-sg-n">' + n + '</span><b>' + esc(title) + '</b></div>'
      + (how ? '<p class="bl-sg-how">' + esc(how) + '</p>' : '')
      + '<div class="bl-sg-in"><input type="number" inputmode="decimal" aria-label="' + esc(title) + ' in ' + S.unit + '" data-bl-sg-num="' + m.key + '" value="' + (v == null ? '' : num(v)) + '" placeholder="' + num((min + max) / 2) + '"> <span class="bl-sg-u">' + S.unit + '</span>'
      + '<input type="range" aria-label="' + esc(title) + ' slider" min="' + min + '" max="' + max + '" step="0.5" value="' + (v == null ? (min + max) / 2 : Math.max(min, Math.min(max, v))) + '" data-bl-sg-rng="' + m.key + '"></div>'
      + '<div class="bl-sg-tape" data-bl-sg-tape="' + m.key + '" data-min="' + min + '" data-max="' + max + '">' + zones + '<div class="bl-sg-needle" style="left:' + pos + '%' + (v == null ? ';display:none' : '') + '"></div></div>'
      + '<div class="bl-sg-ticks">' + ticks + '</div>'
      + '<div class="bl-sg-ans" aria-live="polite">' + ans + '</div></div>';
  }
  function unitSwitch() {
    return '<div class="bl-sg-unit" role="group" aria-label="Units"><button type="button" data-bl-sg-unit="mm" class="' + (S.unit === 'mm' ? 'is-on' : '') + '">mm</button><button type="button" data-bl-sg-unit="cm" class="' + (S.unit === 'cm' ? 'is-on' : '') + '">cm</button></div>';
  }
  function peopleRow(withAdd) {
    if (!withAdd && S.people.length < 2) return '';
    return '<div class="bl-sg-who">' + S.people.map(function (q, i) {
      return '<button type="button" data-bl-sg-who="' + i + '" class="' + (i === cur ? 'is-on' : '') + '">' + esc(q.name) + (q.kind === 'women' ? ' · women’s' : q.kind === 'kids' ? ' · kids' : '') + '</button>';
    }).join('') + (withAdd ? '<button type="button" class="bl-sg-add" data-bl-sg-add="1">+ Add Someone</button>' : '') + '</div>'
      + (withAdd ? '<div class="bl-sg-addform" hidden><input type="text" maxlength="24" placeholder="A name or nickname" aria-label="Name or nickname"><div class="bl-sg-kinds"><button type="button" data-bl-sg-kind="men" class="is-on">Men’s</button><button type="button" data-bl-sg-kind="women">Women’s</button><button type="button" data-bl-sg-kind="kids">Kids’</button></div><button type="button" class="bl-sg-addgo" data-bl-sg-addgo="1">Add</button></div>' : '');
  }
  function saveBtn() {
    var p = person();
    return '<button type="button" class="bl-sg-save" data-bl-sg-save="1">💾 Save ' + (p.name === 'Me' ? 'my' : esc(p.name) + '’s') + ' Sizes</button>'
      + '<p class="bl-sg-saved" data-bl-sg-savednote>' + (S.saved ? 'Saved on this device. Next time, this page picks the size for you.' : 'Saved on this device only, so next time the page picks the size for you.') + '</p>';
  }

  // ---------- 1. the product's own guide (over the page) ----------
  var ovl = null, lastBtn = null, tickTimer = null;
  function productHTML(d) {
    var p = person(), title = d.title || 'This Product';
    var blocks = d.measures.map(function (m, i) { return tapeBlock(m, d.measures.length > 1 ? i + 1 : '✓', p); }).join('');
    var a = answer(d, p), both = '';
    if (d.measures.length > 1 && a && a.value) both = '<div class="bl-sg-both">Take the bigger of the two: <b>' + esc(a.value) + '</b></div>';
    var t = d.table, table = '';
    if (t && t.rows && t.rows.length) {
      table = '<details class="bl-sg-own"><summary>' + esc(t.title || 'The Maker’s Own Measurements (cm)') + '</summary><div class="bl-sg-tw"><table><thead><tr>'
        + t.head.map(function (h) { return '<th>' + esc(h) + '</th>'; }).join('') + '</tr></thead><tbody>'
        + t.rows.map(function (r) { return '<tr>' + r.map(function (c, j) { return j ? '<td>' + esc(c) + '</td>' : '<th>' + esc(c) + '</th>'; }).join('') + '</tr>'; }).join('')
        + '</tbody></table></div>' + (t.kind === 'garment' ? '<p class="bl-sg-small">These are the garment’s own measurements, all the way round, not your body.' + (d.measures.some(function (m) { return m.key === 'chest'; }) ? ' The chest tape above has already allowed for room to move.' : '') + '</p>' : '') + '</details>';
    }
    // the Size Guide tab when the page has one (Tabs Studio drops it after a size change), else the My Sizes page
    var tabLink = '<button type="button" class="bl-sg-totab" data-bl-sg-totab="1">See the Whole Size Guide (Chest, Waist &amp; Foot)</button>';
    return '<h3 id="bl-sg-h">Size Guide: Find your Fit</h3>'
      + peopleRow(false)
      + '<div class="bl-sg-top"><p class="bl-sg-sub">Measure once, type it in or slide the tape, and we tick the size for you.</p>' + unitSwitch() + '</div>'
      + blocks + both
      + (d.fit ? '<p class="bl-sg-fit"><b>How it fits:</b> ' + esc(d.fit) + '</p>' : '')
      + table
      + (d.note ? '<p class="bl-sg-small">' + esc(d.note) + '</p>' : '')
      + saveBtn() + tabLink;
  }
  function openProduct(btn) {
    var d = dataFor(btn); if (!d) return;
    if (SG.mode === 'tab' && findTab()) { goToTab(); return; }
    lastBtn = btn; cur = S.shopFor; wholeInOvl = false;
    if (!ovl) {
      ovl = document.createElement('div'); ovl.className = 'bl-sg-ovl'; ovl.hidden = true;
      ovl.innerHTML = '<div class="bl-sg-box" role="dialog" aria-modal="true" aria-labelledby="bl-sg-h"><button type="button" class="bl-sg-x" aria-label="Close the Size Guide">×</button><div class="bl-sg-body"></div></div>';
      document.body.appendChild(ovl);
      ovl.addEventListener('click', function (e) { if (e.target === ovl) closeProduct(); });
    }
    ovl._d = d; ovl._scope = btn;
    ovl.querySelector('.bl-sg-body').innerHTML = productHTML(d);
    ovl.hidden = false; document.documentElement.classList.add('bl-sg-lock');
    var first = ovl.querySelector('input[type="number"]'); if (first) first.focus({ preventScroll: true });
  }
  function closeProduct() {
    if (!ovl || ovl.hidden) return;
    ovl.hidden = true; document.documentElement.classList.remove('bl-sg-lock');
    if (lastBtn && document.contains(lastBtn)) lastBtn.focus({ preventScroll: true });
    else { var b = document.querySelector('[data-bl-sg-open]'); if (b) b.focus({ preventScroll: true }); }
  }
  // The whole guide (chest, waist, foot) can also open inside this panel: Tabs Studio drops the Size Guide tab after
  // any size change, so "See the Whole Size Guide" shows it here instead of sending the customer off the product page.
  var wholeInOvl = false;
  function rerenderProduct(focusSel) {
    if (!ovl || ovl.hidden) return;
    var body = ovl.querySelector('.bl-sg-body'), y = ovl.scrollTop;
    body.innerHTML = wholeInOvl
      ? '<button type="button" class="bl-sg-back" data-bl-sg-back="1">← Back to This Product’s Tape</button>' + tabHTML()
      : productHTML(ovl._d);
    ovl.scrollTop = y;
    if (focusSel) { var f = body.querySelector(focusSel); if (f) { f.focus({ preventScroll: true }); if (f.type === 'number') { var v = f.value; f.value = ''; f.value = v; } } }
  }

  // ---------- 2. the Size Guide tab (the measure-once guide) ----------
  function findTab() {
    var links = document.querySelectorAll('a.station-tabs-link');
    for (var i = 0; i < links.length; i++) { if (links[i].textContent.replace(/\s+/g, ' ').trim().toLowerCase() === 'size guide') return links[i]; }
    return null;
  }
  function tabPanel() {
    var page = document.getElementById('bl-sg-page'); if (page) return page;   // the "My Sizes" page (templates/page.my-sizes.liquid)
    var a = findTab(); if (!a) return null;
    var id = (a.getAttribute('href') || '').replace(/^#/, ''); if (!id) return null;
    var panel = document.getElementById('st-' + id) || document.getElementById(id);
    if (!panel) { var all = document.querySelectorAll('.station-tabs-content'); for (var i = 0; i < all.length; i++) { if ((all[i].id || '').indexOf(id) >= 0) { panel = all[i]; break; } } }
    return panel ? (panel.querySelector('.station-tabs-content-inner') || panel) : null;
  }
  function goToTab() {
    var a = findTab(); if (!a) { window.location.href = '/pages/my-sizes'; return; }
    // Tabs Studio keeps every panel display:block and marks the open tab's link "is-active"
    if (!a.classList.contains('is-active')) a.click();
    setTimeout(function () { var t = tabPanel(); (t || a).scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 60);
  }
  function tabHTML() {
    var p = person(), kind = p.kind || 'men', wm = kind === 'women', kid = kind === 'kids';
    var d = dataFor(document.body), thisLine = '';
    if (d) { var a = answer(d, p); if (a && a.value) thisLine = 'this one: ' + a.value; else if (a && a.over) thisLine = 'this one’s chart stops at ' + d.measures[0].sizes[d.measures[0].sizes.length - 1].value; }
    var mk = function (rows) { return { sizes: rows.map(function (r) { return { value: r[0], max: r[1] }; }) }; };
    var bl = '';
    var chest = mk(wm ? CH.wb : CH.jk), waist = mk(wm ? CH.ww : CH.pa), foot = mk(CH.ft);
    chest.key = 'chest'; waist.key = 'waist'; foot.key = 'foot';
    var chestThis = d && d.measures.some(function (m) { return m.key === 'chest'; }) ? thisLine : '';
    var waistThis = d && d.measures.some(function (m) { return m.key === 'waist'; }) ? thisLine : '';
    var footThis = d && d.measures.some(function (m) { return m.key === 'foot'; }) ? thisLine : '';
    if (kid) {
      bl = '<p class="bl-sg-sub">Kids’ sizes come from each product’s own guide. Save the measurements here and each product picks the size.</p>'
        + tapeBlock(chest, 1, p, { pickWord: 'adult jackets & jumpers', fitsWord: 'a chest', extra: 'adult sizes shown', noEdge: true })
        + tapeBlock(foot, 3, p, { pickWord: 'boots', fitsWord: 'a foot', extra: 'example: our Lace-Up Field Boots', noEdge: true });
    } else {
      bl = tapeBlock(chest, 1, p, { title: wm ? 'Bust' : 'Chest', how: wm ? 'Run the tape round the fullest part of your bust, under the arms. Keep it level and snug, not tight.' : null, pickWord: wm ? 'women’s tops' : 'jackets & jumpers', fitsWord: wm ? 'a bust' : 'a chest', extra: chestThis, noEdge: true })
        + tapeBlock(waist, 2, p, { pickWord: wm ? 'women’s pants' : 'pants & shorts', fitsWord: 'a waist', extra: waistThis, noEdge: true })
        + tapeBlock(foot, 3, p, { pickWord: 'boots', fitsWord: 'a foot', extra: footThis || 'example: our Lace-Up Field Boots', noEdge: true });
    }
    var fig = '<svg class="bl-sg-fig" width="150" height="240" viewBox="0 0 150 240" aria-hidden="true"><g fill="#11131c" stroke="#5a607a" stroke-width="2"><circle cx="75" cy="26" r="19"/><path d="M45 54 Q75 44 105 54 L118 116 L106 118 L100 80 L100 136 L96 214 L80 214 L75 146 L70 214 L54 214 L50 136 L50 80 L44 118 L32 116 Z"/><path d="M54 214 L44 226 L70 226 L70 214 M80 214 L80 226 L106 226 L96 214"/></g>'
      + '<line x1="48" y1="74" x2="102" y2="74" stroke="#F0CC3D" stroke-width="4" stroke-dasharray="6 4"/><circle cx="48" cy="74" r="9" fill="#F0CC3D"/><text x="48" y="78" font-size="11" font-weight="900" text-anchor="middle" fill="#111">1</text>'
      + '<line x1="51" y1="108" x2="99" y2="108" stroke="#F0CC3D" stroke-width="4" stroke-dasharray="6 4"/><circle cx="51" cy="108" r="9" fill="#F0CC3D"/><text x="51" y="112" font-size="11" font-weight="900" text-anchor="middle" fill="#111">2</text>'
      + '<line x1="44" y1="226" x2="70" y2="226" stroke="#F0CC3D" stroke-width="4"/><circle cx="36" cy="224" r="9" fill="#F0CC3D"/><text x="36" y="228" font-size="11" font-weight="900" text-anchor="middle" fill="#111">3</text></svg>';
    return '<div class="bl-sg bl-sg-tab"><h3>Size Guide: Find your Fit</h3><p class="bl-sg-sub">Measure once, see your size in everything, and save it for next time.</p>'
      + peopleRow(true)
      + '<div class="bl-sg-grid">' + fig + '<div>' + unitSwitch() + bl + '</div></div>'
      + saveBtn() + '</div>';
  }
  var tabEl = null;
  function renderTab(focusSel) {
    var inner = tabPanel(); if (!inner) return;
    if (!inner.querySelector('.bl-sg-tab')) { inner.setAttribute('data-bl-sg-old', '1'); }
    var y = window.scrollY;
    inner.innerHTML = tabHTML(); tabEl = inner;
    window.scrollTo(0, y);
    if (focusSel) { var f = inner.querySelector(focusSel); if (f) { f.focus({ preventScroll: true }); if (f.type === 'number') { var v = f.value; f.value = ''; f.value = v; } } }
  }

  // ---------- 3. the product page: note + "Shopping for" + auto-pick ----------
  var autoDone = false, autoNote = '';
  function refreshPage() {
    var wrap = document.querySelector('.product-info .bl-sg-wrap') || document.querySelector('.bl-sg-wrap'); if (!wrap) return;
    var d = dataFor(wrap); if (!d) return;
    var fs = sizeFieldset(pickerFor(wrap), d);
    // Shopping for (only once someone other than Me is saved)
    var bar = fs && fs.parentNode.querySelector('.bl-sg-shop');
    if (S.saved && S.people.length > 1 && fs) {
      if (!bar) { bar = document.createElement('div'); bar.className = 'bl-sg-shop'; fs.parentNode.insertBefore(bar, fs); }
      var bh = '<label>Shopping for: <select data-bl-sg-shop="1">' + S.people.map(function (q, i) { return '<option value="' + i + '"' + (i === S.shopFor ? ' selected' : '') + '>' + esc(q.name) + '</option>'; }).join('') + '</select></label>';
      if (bar._h !== bh) { bar.innerHTML = bh; bar._h = bh; }   // only touch the page when something changed (the observer below watches it)
    } else if (bar) bar.remove();
    // auto-pick from saved sizes (once per page, never over a size the URL asked for)
    if (S.saved && !autoDone) {
      autoDone = true;
      var p = S.people[S.shopFor], a = p && answer(d, p);
      if (a && a.value && !/[?&]variant=/.test(location.search)) { if (tick(d, a.value, wrap)) autoNote = '✓ ' + a.value + ' picked for you from ' + nameOf(p) + ' saved sizes'; }
      else if (a && a.over) autoNote = 'No size for ' + (p.name === 'Me' ? 'you' : p.name) + ' in this one: its chart stops at ' + d.measures[0].sizes[d.measures[0].sizes.length - 1].value + '.';
    }
    var note = wrap.querySelector('.bl-sg-auto');
    if (note && (note.textContent !== autoNote || note.hidden !== !autoNote)) { note.textContent = autoNote; note.hidden = !autoNote; }
  }

  // ---------- events ----------
  function setMeasure(key, cm, from) {
    var p = person(); p[key] = cm;
    if (cur === S.shopFor) autoNote = '';
  }
  function afterMeasure(from) {
    // re-draw the guide that changed, keep focus where the customer is typing
    var sel = from.hasAttribute('data-bl-sg-num') ? '[data-bl-sg-num="' + from.getAttribute('data-bl-sg-num') + '"]' : '[data-bl-sg-rng="' + from.getAttribute('data-bl-sg-rng') + '"]';
    if (ovl && !ovl.hidden && ovl.contains(from)) {
      rerenderProduct(sel);
      clearTimeout(tickTimer);
      tickTimer = setTimeout(function () { var a = answer(ovl._d, person()); if (a && a.value && cur === S.shopFor) tick(ovl._d, a.value, ovl._scope); }, 350);
    } else if (tabEl && tabEl.contains(from)) {
      renderTab(sel);
      // the tab ticks this product's own size too, when the measurement is one this product is sized by
      var d = dataFor(document.body), key = from.getAttribute('data-bl-sg-num') || from.getAttribute('data-bl-sg-rng');
      if (d && cur === S.shopFor && d.measures.some(function (m) { return m.key === key; })) {
        clearTimeout(tickTimer);
        tickTimer = setTimeout(function () { var a = answer(d, person()); if (a && a.value) tick(d, a.value, document.querySelector('.bl-sg-wrap') || document.body); }, 350);
      }
    }
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    var open = t.closest('[data-bl-sg-open]'); if (open) { e.preventDefault(); openProduct(open); return; }
    if (t.closest('.bl-sg-x')) { closeProduct(); return; }
    var inGuide = t.closest('.bl-sg-ovl, .bl-sg-tab'); if (!inGuide) return;
    var un = t.closest('[data-bl-sg-unit]'); if (un) { S.unit = un.getAttribute('data-bl-sg-unit'); if (S.saved) store(); rerenderProduct(); if (tabEl) renderTab(); return; }
    var w = t.closest('[data-bl-sg-who]'); if (w) { cur = +w.getAttribute('data-bl-sg-who'); rerenderProduct(); if (tabEl) renderTab(); return; }
    if (t.closest('[data-bl-sg-add]')) { var f = inGuide.querySelector('.bl-sg-addform'); if (f) { f.hidden = !f.hidden; if (!f.hidden) f.querySelector('input').focus(); } return; }
    var kd = t.closest('[data-bl-sg-kind]'); if (kd) { kd.parentNode.querySelectorAll('button').forEach(function (b) { b.classList.toggle('is-on', b === kd); }); return; }
    if (t.closest('[data-bl-sg-addgo]')) {
      var form = inGuide.querySelector('.bl-sg-addform'), nm = form.querySelector('input').value.trim().slice(0, 24);
      if (!nm) { form.querySelector('input').focus(); return; }
      var kind = (form.querySelector('[data-bl-sg-kind].is-on') || {}).getAttribute ? form.querySelector('[data-bl-sg-kind].is-on').getAttribute('data-bl-sg-kind') : 'men';
      S.people.push({ name: nm, kind: kind }); cur = S.people.length - 1; renderTab(); rerenderProduct(); return;
    }
    if (t.closest('[data-bl-sg-save]')) {
      S.saved = true; var ok = store(); autoDone = false; autoNote = '';
      var n = inGuide.querySelector('[data-bl-sg-savednote]');
      if (n) n.textContent = ok ? '✅ Saved on this device: ' + S.people.map(function (q) { return q.name; }).join(', ') + '.' : 'Couldn’t save on this device (private browsing, or saving is switched off). The tape still works.';
      if (!ok) S.saved = false;
      refreshPage(); return;
    }
    if (t.closest('[data-bl-sg-totab]')) {
      // always inside this panel: jumping to the tab closed the panel and showed nothing on a phone (checker, 14 Oct, live)
      wholeInOvl = true; rerenderProduct(); if (ovl) ovl.scrollTop = 0;
      return;
    }
    if (t.closest('[data-bl-sg-back]')) { wholeInOvl = false; rerenderProduct(); if (ovl) ovl.scrollTop = 0; return; }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && ovl && !ovl.hidden) { closeProduct(); return; }
    if (e.key === 'Tab' && ovl && !ovl.hidden) {     // keep Tab inside the open guide
      var f = ovl.querySelectorAll('button, input, select, summary, [tabindex]:not([tabindex="-1"])'); if (!f.length) return;
      var a = f[0], z = f[f.length - 1];
      if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
      else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
    }
    if (e.key === 'Enter' && e.target.closest && e.target.closest('.bl-sg-addform')) { var go = e.target.closest('.bl-sg-addform').querySelector('[data-bl-sg-addgo]'); if (go) { e.preventDefault(); go.click(); } }
  });
  document.addEventListener('input', function (e) {
    var t = e.target; if (!t.closest || !t.closest('.bl-sg-ovl, .bl-sg-tab')) return;
    var key = t.getAttribute('data-bl-sg-num') || t.getAttribute('data-bl-sg-rng'); if (!key) return;
    var cm = t.hasAttribute('data-bl-sg-num') ? (+t.value) / k() : +t.value;
    if (!(cm > 0)) return;
    if (t.hasAttribute('data-bl-sg-num')) { var tape = t.closest('.bl-sg-block').querySelector('[data-bl-sg-tape]'); if (cm < +tape.getAttribute('data-min') * 0.5) return; } // still typing the first digits
    setMeasure(key, cm, t); afterMeasure(t);
  });
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches && t.matches('[data-bl-sg-shop]')) { S.shopFor = cur = +t.value; store(); autoDone = false; autoNote = ''; var d = dataFor(t); var p = S.people[S.shopFor]; var a = d && answer(d, p); if (a && a.value) { tick(d, a.value, t); autoNote = '✓ ' + a.value + ' picked for ' + (p.name === 'Me' ? 'you' : p.name) + ' from ' + nameOf(p) + ' saved sizes'; autoDone = true; } else if (a && a.over) { autoNote = 'No size for ' + p.name + ' in this one.'; autoDone = true; } else { autoNote = ''; autoDone = true; } refreshPage(); return; }
    // a size picked by hand (a real click, not our tick) clears the "picked for you" note
    if (e.isTrusted && t.matches && t.matches('input[type="radio"]') && t.closest('fieldset.option-selector') && autoNote) { autoNote = ''; refreshPage(); }
  }, true);
  // The theme re-draws the picker on every variant change: put the note and the Shopping-for bar back each time.
  var mo = new MutationObserver(function () { clearTimeout(mo._t); mo._t = setTimeout(function () { refreshPage(); var inner = tabPanel(); if (inner && !inner.querySelector('.bl-sg-tab')) renderTab(); }, 60); });
  function start() {
    refreshPage();
    var inner = tabPanel(); if (inner) renderTab();
    var root = document.querySelector('.product-info') || document.body;
    mo.observe(root, { childList: true, subtree: true });
    // Tabs Studio rebuilds the tabs on every size change: watch the main area so a rebuilt Size Guide tab gets the guide again
    var main = document.querySelector('main'); if (main && main !== root && !root.contains(main)) mo.observe(main, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  SG.open = openProduct; SG.renderTab = renderTab; SG.refresh = refreshPage; SG.state = function () { return S; };
})();
